// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sHCQCC {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-2); /* 16px */
}

.Q_NbTG {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #ffffff; /* Fundo branco exato do Figma */
  z-index: 9999;
}

.xr9Y4L {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Tamanhos baseados no design do Figma */
.LJNkbM .xr9Y4L {
  width: 16px;
  height: 16px;
}

.QXRm8E .xr9Y4L {
  width: 32px;
  height: 32px;
}

.uoKwoO .xr9Y4L {
  width: 44px; /* Tamanho exato do Figma: 44x44px */
  height: 44px; /* Tamanho exato do Figma: 44x44px */
}

.rN6tRj .xr9Y4L {
  width: 56px;
  height: 56px;
}

/* Círculo base - borda cinza de fundo */
.X1QgAG {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 3px solid #d9d9d9; /* Borda cinza do Figma */
  background: transparent; /* Sem background */
}

/* Círculo de progresso - borda laranja animada */
.mPf2NA {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 3px solid transparent; /* Base transparente */
  border-top: 3px solid #d64000; /* Apenas o topo com cor laranja do Figma */
  background: transparent; /* Sem background */
  animation: PYXvLl 1.2s linear infinite;
}

.LJNkbM .X1QgAG {
  border: 2px solid #d9d9d9; /* Borda cinza do Figma */
}

.LJNkbM .mPf2NA {
  border: 2px solid transparent; /* Base transparente */
  border-top: 2px solid #d64000; /* Apenas o topo com cor laranja do Figma */
}

.SvDqit {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md); /* 14px */
  font-weight: var(--font-weight-regular); /* 400 */
  color: var(--text-neutral-stronger);
  margin: 0;
  text-align: center;
}

/* Animação de rotação da borda */
@keyframes PYXvLl {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Variações responsivas */
@media (max-width: 768px) {
  .sHCQCC {
    gap: var(--spacing-1-5); /* 12px em mobile */
  }

  .SvDqit {
    font-size: var(--font-size-sm); /* 12px em mobile */
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/Loading/Loading.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB,EAAE,SAAS;AAClC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,yBAAyB,EAAE,gCAAgC;EAC3D,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW,EAAE,oCAAoC;EACjD,YAAY,EAAE,oCAAoC;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB,EAAE,yBAAyB;EACpD,uBAAuB,EAAE,mBAAmB;AAC9C;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B,EAAE,sBAAsB;EACrD,6BAA6B,EAAE,2CAA2C;EAC1E,uBAAuB,EAAE,mBAAmB;EAC5C,sCAAoC;AACtC;;AAEA;EACE,yBAAyB,EAAE,yBAAyB;AACtD;;AAEA;EACE,6BAA6B,EAAE,sBAAsB;EACrD,6BAA6B,EAAE,2CAA2C;AAC5E;;AAEA;EACE,oCAAoC;EACpC,8BAA8B,EAAE,SAAS;EACzC,uCAAuC,EAAE,QAAQ;EACjD,mCAAmC;EACnC,SAAS;EACT,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,uBAAuB,EAAE,mBAAmB;EAC9C;;EAEA;IACE,8BAA8B,EAAE,mBAAmB;EACrD;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-2); /* 16px */\n}\n\n.fullScreen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: #ffffff; /* Fundo branco exato do Figma */\n  z-index: 9999;\n}\n\n.spinner {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Tamanhos baseados no design do Figma */\n.micro .spinner {\n  width: 16px;\n  height: 16px;\n}\n\n.small .spinner {\n  width: 32px;\n  height: 32px;\n}\n\n.medium .spinner {\n  width: 44px; /* Tamanho exato do Figma: 44x44px */\n  height: 44px; /* Tamanho exato do Figma: 44x44px */\n}\n\n.large .spinner {\n  width: 56px;\n  height: 56px;\n}\n\n/* Círculo base - borda cinza de fundo */\n.circleBase {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  border: 3px solid #d9d9d9; /* Borda cinza do Figma */\n  background: transparent; /* Sem background */\n}\n\n/* Círculo de progresso - borda laranja animada */\n.circleProgress {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  border: 3px solid transparent; /* Base transparente */\n  border-top: 3px solid #d64000; /* Apenas o topo com cor laranja do Figma */\n  background: transparent; /* Sem background */\n  animation: spin 1.2s linear infinite;\n}\n\n.micro .circleBase {\n  border: 2px solid #d9d9d9; /* Borda cinza do Figma */\n}\n\n.micro .circleProgress {\n  border: 2px solid transparent; /* Base transparente */\n  border-top: 2px solid #d64000; /* Apenas o topo com cor laranja do Figma */\n}\n\n.message {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md); /* 14px */\n  font-weight: var(--font-weight-regular); /* 400 */\n  color: var(--text-neutral-stronger);\n  margin: 0;\n  text-align: center;\n}\n\n/* Animação de rotação da borda */\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Variações responsivas */\n@media (max-width: 768px) {\n  .container {\n    gap: var(--spacing-1-5); /* 12px em mobile */\n  }\n\n  .message {\n    font-size: var(--font-size-sm); /* 12px em mobile */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `sHCQCC`,
	"fullScreen": `Q_NbTG`,
	"spinner": `xr9Y4L`,
	"micro": `LJNkbM`,
	"small": `QXRm8E`,
	"medium": `uoKwoO`,
	"large": `rN6tRj`,
	"circleBase": `X1QgAG`,
	"circleProgress": `mPf2NA`,
	"spin": `PYXvLl`,
	"message": `SvDqit`
};
module.exports = ___CSS_LOADER_EXPORT___;
